import { Controller } from "@hotwired/stimulus"

// Modale « Historique du document » (Documents::HistoryComponent).
// - Le PDF d'une version ne se charge qu'au dépliage de sa ligne : une frise peut en compter des dizaines.
//   Le clic sur la ligne bascule `is-open` (depozen-ui-timeline) avant de remonter jusqu'ici.
// - Quand une version vient d'être créée (« Régénérer à la date du jour »), la page se recharge à la
//   fermeture de la modale : la ligne du document affiche alors sa nouvelle date.
// - Une attestation à une date antérieure tout juste générée s'ouvre d'elle-même, son PDF chargé.
export default class extends Controller {
  static values = { changed: Boolean, open: String }

  connect() {
    this.modal = this.element.closest(".modal")
    this.loadOpenPreviews = this.loadOpenPreviews.bind(this)
    this.reloadIfChanged = this.reloadIfChanged.bind(this)
    this.element.addEventListener("click", this.loadOpenPreviews)
    this.modal?.addEventListener("hidden.bs.modal", this.reloadIfChanged)
    // La frise (depozen-ui-timeline, contrôleur enfant) range ses lignes à sa propre connexion.
    if (this.openValue) requestAnimationFrame(() => this.openVersion(this.openValue))
  }

  disconnect() {
    this.element.removeEventListener("click", this.loadOpenPreviews)
    this.modal?.removeEventListener("hidden.bs.modal", this.reloadIfChanged)
  }

  loadOpenPreviews() {
    this.element
      .querySelectorAll(".depozen-ui-timeline__item.is-open iframe[data-document-history-src]")
      .forEach((frame) => {
        frame.src = frame.dataset.documentHistorySrc
        delete frame.dataset.documentHistorySrc
      })
  }

  openVersion(id) {
    const item = this.element.querySelector(`.depozen-ui-timeline__item[data-event-id="${CSS.escape(id)}"]`)
    const row = item?.querySelector(".depozen-ui-timeline__row")
    if (!row || item.classList.contains("is-open")) return

    row.click()
    item.scrollIntoView({ block: "nearest" })
  }

  reloadIfChanged() {
    if (!this.changedValue) return

    window.Turbo.visit(window.location.href, { action: "replace" })
  }
}
